import { render, staticRenderFns } from "./ProductCalculation.vue?vue&type=template&id=e40ad08e&scoped=true&"
import script from "./ProductCalculation.vue?vue&type=script&lang=js&"
export * from "./ProductCalculation.vue?vue&type=script&lang=js&"
import style0 from "./ProductCalculation.vue?vue&type=style&index=0&id=e40ad08e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40ad08e",
  null
  
)

export default component.exports